import { render } from "./TransactionCard.vue?vue&type=template&id=3139b195&scoped=true"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"

import "./TransactionCard.vue?vue&type=style&index=0&id=3139b195&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3139b195"]])

export default __exports__